import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Image,
  Row,
  Spinner,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import BreadcrumbSection from "components/BreadcrumbSection";
import IMAGES from "constants/images";
import CommonModal from "components/CommonModal";
import TextInput from "components/TextInput";
import VendorSidebar from "inc/VendorSidebar";
import { useAuth } from "context/UserContext";
import { Sentry } from "react-activity";
import { createBadgeRequest, getAllUserbadges } from "api/BadgeRequestsService";
import { toast } from "react-toastify";
import Loader from "components/Loader";
import { useNavigate } from "react-router-dom";
// const badgesData = [
//   {
//     title: "High Performer",
//     image: IMAGES.Badgecolor1_IMG,
//     status: "Approved",
//     color: "#E1FBFF",
//   },
//   {
//     title: "Customer Satisfaction Badge",
//     image: IMAGES.Badge1_IMG,
//     status: "Requested",
//     color: "#F4F4F4",
//   },
//   {
//     title: "Enterprise Leader",
//     image: IMAGES.Badge2_IMG,
//     status: "Request Badge",
//     color: "#F4F4F4",
//   },
//   {
//     title: "Best Vendor Relationships",
//     status: "Request Badge",
//     color: "#F4F4F4",
//     image: IMAGES.Badge1_IMG,
//   },
//   {
//     title: "Fast-Growing Products",
//     image: IMAGES.Badge2_IMG,
//     status: "Request Badge",
//     color: "#F4F4F4",
//   },
//   {
//     title: "Best Usability of Products",
//     image: IMAGES.Badgecolor2_IMG,
//     status: "Approved",
//     color: "#FFE1DB",
//   },
//   {
//     title: "Outstanding Customer Service",
//     status: "Request Badge",
//     color: "#F4F4F4",
//     image: IMAGES.Badge1_IMG,
//   },
//   {
//     title: "Users Love Us",
//     image: IMAGES.Badge2_IMG,
//     status: "Request Badge",
//     color: "#F4F4F4",
//   },
//   {
//     title: "Momentum Leader",
//     image: IMAGES.Badge1_IMG,
//     status: "Request Badge",
//     color: "#F4F4F4",
//   },
//   {
//     title: "Spotlight of the Week",
//     image: IMAGES.Badgecolor3_IMG,
//     status: "Approved",
//     color: "#DEDAFF",
//   },
// ];

const BadgeCard = ({
  id,
  title,
  status,
  colorCode,
  icon,
  description,
  setShowModal,
  setShowModal2,
}) => {
  return (
    <Card
      className="text-center"
      style={{ backgroundColor: status !== "approved" ? "#F4F4F4" : colorCode }}
    >
      <Card.Body>
        <div
          onClick={() => {
            setShowModal2({
              data: {
                title,
                description: description,
                id,
              },
              value: true,
            });
          }}
          className={`badge-icon cursor-pointer  }`}
          style={{
            backgroundColor: status !== "approved" ? "#F4F4F4" : colorCode,
          }}
        >
          <Image
            src={icon}
            alt=""
            style={{
              height: "56px",
              width: "56px",
              objectFit: "contain",
              filter:
                status !== "approved"
                  ? "grayscale(100%) opacity(0.4) "
                  : "none",
            }}
          />
        </div>
        <Card.Title>{title}</Card.Title>
        {status === "approved" && (
          <Badge className="btnFix" bg="success">
            Approved
          </Badge>
        )}
        {status === "requested" && (
          <Badge className="btnFix" bg="success">
            Requested
          </Badge>
        )}
        {["none", "rejected"].includes(status) && (
          <Button
            className="btnFix"
            variant="danger"
            onClick={() =>
              setShowModal({
                data: id,
                value: true,
              })
            }
          >
            Request Badge
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

const MyBadges = () => {
  const navigate=useNavigate()
  const [showFollowers, setShowFollowers] = useState(false);
  const [showModal, setShowModal] = useState({ data: null, value: false });
  const [showModal2, setShowModal2] = useState(false);
  const [uiLoading, setUiLoading] = useState(true);
  const [badgesData, setBadgesData] = useState([]);
  const [reason, setReason] = useState("");
  const [requestLoader, setRequestLoader] = useState(false);

  const handleRequstBadge = async () => {
    try {
      const payload = {
        userId,
        reason: reason.trim(),
        badgeId: showModal.data,
      };
      setRequestLoader(true);
      const res = await createBadgeRequest(payload);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        fetchBadges();
        handleCloseModal();
      } else {
        toast.error(res.message);
      }
      setRequestLoader(false);
    } catch (err) {
      setRequestLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleCloseModal = () => {
    setReason("");
    setShowModal({ data: null, value: false });
  };
  const handleCloseModal2 = () => {
    setShowModal2({ data: null, value: false });
  };
  const { user } = useAuth();
  const userId = user ? user._id : "";
  const fetchBadges = async () => {
    try {
      const res = await getAllUserbadges({
        userId,
      }); // API call
      if (res.success) {
        setBadgesData(res.body);
      }
      setUiLoading(false);
    } catch (error) {
      setUiLoading(false);

      console.error("Error fetching reviews:", error);
    } finally {
      setUiLoading(false);
      // setLoading(false);
    }
  };

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (user && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchBadges();
    }
  }, [user]);
  return (
    <React.Fragment>
      <Col lg={12} xl={12}>
        <div className="profile_details_style header_profile3">
          <h3>My Badges</h3>
        </div>
        <div className="profile_details_style mb-3 header_profile2  d-flex  justify-content-between ">
        <div className="d-flex align-items-center">
      <Icon icon="mdi:arrow-left" style={{fontSize: "24px"}} className="me-4" onClick={() => navigate("/vendor/my-profile")}/>
      <h3 className="mb-0">My Badges</h3>
      </div>
      </div>
        <p className="details_para">
          Become a Verified Vendor! Request badges for your active
          contributions, level up, and showcase your achievements on your
          profile. Grow your business and enjoy the journey!
        </p>
        <Row className="badge_card">
          {uiLoading ? (
            <div
              className="d-flex justify-content-center align-items-center "
              style={{ minHeight: "50vh" }}
            >
              <Sentry color="#e91515" size={40} speed={1} animating={true} />
              {/* <Loader  style={{width: 100, height: 100}} /> */}
            </div>
          ) : badgesData?.length > 0 ? (
            badgesData?.map((badge, index) => (
              <Col  sm={6} md={6} lg={3} key={index}>
                <BadgeCard
                  {...badge}
                  id={badge._id}
                  setShowModal={setShowModal}
                  setShowModal2={setShowModal2}
                />
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <div className="text-center py-5">
                <Image
                  src={IMAGES.emptyState}
                  alt=""
                  height="300px"
                  width="300px"
                  className="mb-4"
                  // className="imgUser"
                />
                <p className="text-center text-muted">No badge found.</p>
              </div>
            </Col>
          )}
        </Row>
      </Col>

      <CommonModal
        title={"Request Badge"}
        para={
          "Tell us why you need this badge and how it will help you access the right features or services."
        }
        image
        className="loginModalNew"
        body={
          <div className="mt-4">
            <TextInput
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              labelText={"Reason"}
              type="text"
              textarea="textarea"
              rows={6}
              placeholder={"Write Your Reason..."}
              // errorMessage={"Reason is required"}
            />

            <Button
              disabled={!reason.trim()}
              onClick={handleRequstBadge}
              variant="info"
              className="w-100 mt-4 border-radius-100"
            >
              {requestLoader ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Continue"
              )}
            </Button>
          </div>
        }
        show={showModal.value}
        onClose={handleCloseModal}
      />
      <CommonModal
        title={`Why you need “${showModal2?.data?.title}” badge? `}
        para={""}
        image
        className="loginModalNew"
        body={
          <div className="mt-4">
            <p>{showModal2?.data?.description}</p>
            <Button
              onClick={handleCloseModal2}
              variant="info"
              className="w-100 mt-4 border-radius-100"
            >
              Got It
            </Button>
          </div>
        }
        show={showModal2?.value}
        onClose={handleCloseModal2}
      />
    </React.Fragment>
  );
};

export default MyBadges;
